// SELETOR DE IDIOMA (GTranslate) + PREÇO NA MOEDA DO IDIOMA — todos os modelos de site (21/10/2026).
//
// Ligado por 2 opções do CRM (Personalizar site › Comportamento), que o site-graphql entrega em
// `site.seletor_idioma` e `site.preco_moeda_idioma` (false por padrão; false em site congelado;
// a moeda só vale com o seletor ligado). O cs2504 (05/10) estreou o recurso com gate por codsite:
// o Set abaixo fica como TRANSIÇÃO até a flag dele ser gravada no banco (F6 do plano) e sai num
// próximo deploy. Fora do gate NADA muda: os componentes mantêm o JSX de sempre, byte a byte
// (SSR idêntico nos ~300 sites).
//
// Este módulo não importa React nem CSS de propósito: é lido pelo servidor (lib/server) e pelos
// componentes.

const TRANSICAO_CODSITES: ReadonlySet<number> = new Set([2504]);

// MODELOS COM IDIOMA + MOEDA SEMPRE LIGADOS (22/10/2026). `modelo_topo` em que o seletor de idioma E o
// preço na moeda do idioma valem para TODO tenant daquele modelo, sem depender das 2 opções do CRM —
// pensado para um modelo voltado a público estrangeiro. 22/10: topo 17 (modelo do compass.com, "Internacional" no
// /produzindo) ligado — Daniel: "fixo o idioma". Pôr um número aqui liga o recurso para todos os sites daquele modelo no próximo deploy
// (o HTML desses sites muda — rodar o A/B SSR). Tenant CONGELADO fica de fora (`site.congelado`), como
// já acontece com as flags do CRM, que o site-graphql entrega false para ele.
export const MODELOS_IDIOMA_SEMPRE: ReadonlySet<number> = new Set<number>([17]);

/** Modelo do site (topo) com idioma + moeda sempre ligados (MODELOS_IDIOMA_SEMPRE), fora congelado. */
const modeloComIdiomaSempre = (site: any): boolean =>
    MODELOS_IDIOMA_SEMPRE.size > 0 && site?.congelado !== true && MODELOS_IDIOMA_SEMPRE.has(Number(site?.modelo_topo));

/** Botão/seletor de idiomas no site — opção "Adicionar campo de idioma no site" (ou modelo "sempre"). */
export const temSeletorIdiomas = (site: any): boolean =>
    site?.seletor_idioma === true || TRANSICAO_CODSITES.has(Number(site?.id)) || modeloComIdiomaSempre(site);

/** Preços convertidos para a moeda do idioma — opção "Alterar preço para moeda do idioma" (exige o seletor). */
export const temConversorMoeda = (site: any): boolean =>
    (site?.preco_moeda_idioma === true && temSeletorIdiomas(site)) || TRANSICAO_CODSITES.has(Number(site?.id)) ||
    modeloComIdiomaSempre(site);

/** Select MANUAL de moeda (R$/US$/€/BTC/ETH) no topo 3 — só o 2504 pediu; os demais seguem o idioma. */
export const temSeletorMoedaManual = (site: any): boolean => TRANSICAO_CODSITES.has(Number(site?.id));

/** Idiomas oferecidos pelo widget (o `de` veio com o 2504 e fica para não regredir). */
export const IDIOMAS_SITE = ['pt', 'en', 'es', 'fr', 'it', 'de'] as const;
